// removed by extract-text-webpack-plugin
module.exports = {"ClientMap":"ClientMap__ClientMap___2wcC7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMap/ClientMap.scss
// module id = 1325
// module chunks = 0